import React from 'react';
import { ActionButton } from '@/store/videoFeatures';

interface ButtonPreviewCardProps {
  actionButton: Partial<ActionButton>;
  variant?: 'below' | 'over';
}

const getPositionClasses = (position?: string): string => {
  switch (position) {
    case 'top-left':
      return 'top-4 left-4';
    case 'top-center':
      return 'top-4 left-1/2 -translate-x-1/2';
    case 'top-right':
      return 'top-4 right-4';
    case 'center-left':
      return 'top-1/2 left-4 -translate-y-1/2';
    case 'center':
      return 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2';
    case 'center-right':
      return 'top-1/2 right-4 -translate-y-1/2';
    case 'bottom-left':
      return 'bottom-4 left-4';
    case 'bottom-center':
      return 'bottom-4 left-1/2 -translate-x-1/2';
    case 'bottom-right':
      return 'bottom-4 right-4';
    default:
      return 'bottom-4 left-1/2 -translate-x-1/2';
  }
};

export const ButtonPreviewCard: React.FC<ButtonPreviewCardProps> = () => {
  return null;
};
